var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile &&
    (_vm.lpu.is_award_or_grand_prix_winner ||
      _vm.lpu.lpu_loyalty_program ||
      (!_vm.lpu.closed && _vm.lpu.license))
    ? _c(_setup.CoreSwiper, {
        staticClass: "mx-n4 px-4 trust-badges",
        attrs: {
          "free-mode": "",
          "slides-per-view": "auto",
          "has-pagination": false,
          "space-between": 8,
          "placeholder-min-height": 28,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "slides",
              fn: function ({ slideAttrs }) {
                return _vm._l(_setup.badgeComponents, function (item) {
                  return _c(
                    "div",
                    _vm._b({ key: item.name }, "div", slideAttrs, false),
                    [
                      _c(
                        item.component,
                        _vm._b(
                          { tag: "component", staticClass: "text-no-wrap" },
                          "component",
                          item.props,
                          false
                        )
                      ),
                    ],
                    1
                  )
                })
              },
            },
          ],
          null,
          false,
          4235386662
        ),
      })
    : _vm.lpu.is_award_or_grand_prix_winner ||
      _vm.lpu.lpu_loyalty_program ||
      (!_vm.lpu.closed && _vm.lpu.license)
    ? _c(
        "div",
        { staticClass: "d-flex align-center gc-3" },
        _vm._l(_setup.badgeComponents, function (item) {
          return _c(
            item.component,
            _vm._b(
              { key: item.name, tag: "component" },
              "component",
              item.props,
              false
            )
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }